export default {
  en: {
    /* ----- Validation Messages ----- */
    // Basic validation messages
    fieldRequired: "{_field_} is required.",
    validEmailRequired: "Please provide a valid email address.",
    onlyNumericsAllowed: "Only numerics are allowed.",

    // Value validation messages
    valueLessThanOrEqual: "The value should be less than or equal to {max}.",
    valueGreaterThanOrEqual:
      "The value should be greater than or equal to {min}.",
    valueGreaterThanOrEqualZero:
      "The value should be greater than or equal to zero.",

    // Length validation messages
    maxCharactersExceeded:
      "The value should not exceed more than {max} characters.",
    minCharactersRequired: "The value should be more than {min} characters.",

    // Format validation messages
    onlyAlphabetsSpaceDotsAllowed:
      "Only alphabets, space and dots are allowed.",
    numericTwoDecimalAllowed:
      "Numeric value with maximum two decimal places are allowed.",
    alphaNumSpaceDotHyphenQuotesAllowed:
      "Only alphanumeric, spaces and symbols( ' . - _ ) are allowed.",
    commentFormatAllowed:
      "Only alphanumeric, spaces and symbols(+ , / . # & : () ' - ) are allowed.",
    alphaNumSpaceSymbolsAllowed:
      "Only alphanumeric,spaces and symbols(& - ) are allowed",
    alphaNumSpaceExtendedSymbolsAllowed:
      "Only alphanumeric, space and symbols ( . , # + & / - ( ) : ` ' ? ) are allowed",
    commonInputAlphaNumericValidationMessage:
      "Only alphanumeric characters, spaces and special characters are allowed",
    numSpaceHyphenAllowed: "Only numeric, spaces and hyphen are allowed.",
    validMobileRequired: "Please provide a valid mobile number.",
    alphaNumSpaceFourSymbolsAllowed:
      "Only alphanumeric, spaces and symbols(- , ( ) )  are allowed.",
    alphaNumSpaceHyphenAllowed:
      "Only alphanumeric, space and hyphen are allowed.",
    alphaNumSpaceAmpBracketAllowed:
      "Only alphanumeric, spaces and symbols(& , () . )  are allowed.",
    designationFormatAllowed:
      "Only alphanumeric, spaces and symbols(+ , / . # & : () ' - ` | _) are allowed.",
    titleFormatAllowed:
      "Only alphanumeric, spaces and symbols(+ , / . # & : () ' - ` ) are allowed.",
    descriptionFormatAllowed:
      "Only letters, numbers, spaces, and special characters(. , ! @ % ^ & * - _ + = ; : ' \" < > ( ) ?) are allowed.",
    validDomainRequired: "Please enter valid domain name",
    alphaNumSpaceBasicSymbolsAllowed:
      "Only alphanumeric, spaces and symbols( + , / . # & : ( ) ' - ) are allowed.",
    onlyAlphaNumericAllowed: "Only alphanumeric characters are allowed.",
    validBSBRequired: "Please provide valid BSB code",
    validIFSCRequired: "Please provide valid IFSC code",
  },
  sp: {
    /* ----- Validation Messages ----- */
    // Basic validation messages
    fieldRequired: "{_field_} es requerido.",
    validEmailRequired:
      "Por favor, proporcione una dirección de correo electrónico válida.",
    onlyNumericsAllowed: "Solo se permiten números.",

    // Value validation messages
    valueLessThanOrEqual: "El valor debe ser menor o igual a {max}.",
    valueGreaterThanOrEqual: "El valor debe ser mayor o igual a {min}.",
    valueGreaterThanOrEqualZero: "El valor debe ser mayor o igual a cero.",

    // Length validation messages
    maxCharactersExceeded: "El valor no debe exceder más de {max} caracteres.",
    minCharactersRequired: "El valor debe tener más de {min} caracteres.",

    // Format validation messages
    onlyAlphabetsSpaceDotsAllowed:
      "Solo se permiten alfabetos, espacios y puntos.",
    numericTwoDecimalAllowed:
      "Se permite valor numérico con máximo dos decimales.",
    alphaNumSpaceDotHyphenQuotesAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos( ' . - _ ).",
    commentFormatAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos(+ , / . # & : () ' - ).",
    alphaNumSpaceSymbolsAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos(& - )",
    alphaNumSpaceExtendedSymbolsAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos ( . , # + & / - ( ) : ` ' ? )",
    commonInputAlphaNumericValidationMessage:
      "Solo se permiten caracteres alfanuméricos, espacios y caracteres especiales.",
    numSpaceHyphenAllowed: "Solo se permiten números, espacios y guiones.",
    validMobileRequired: "Por favor, proporcione un número de móvil válido.",
    alphaNumSpaceFourSymbolsAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos(- , ( ) ).",
    alphaNumSpaceHyphenAllowed:
      "Solo se permiten alfanuméricos, espacios y guiones.",
    alphaNumSpaceAmpBracketAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos(& , () . ).",
    designationFormatAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos(+ , / . # & : () ' - ` | _).",
    titleFormatAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos(+ , / . # & : () ' - ` ).",
    descriptionFormatAllowed:
      "Solo se permiten letras, números, espacios y caracteres especiales(. , ! @ % ^ & * - _ + = ; : ' \" < > ( ) ?).",
    validDomainRequired: "Por favor, ingrese un nombre de dominio válido",
    alphaNumSpaceBasicSymbolsAllowed:
      "Solo se permiten alfanuméricos, espacios y símbolos( + , / . # & : ( ) ' - ).",
    onlyAlphaNumericAllowed: "Solo se permiten caracteres alfanuméricos.",
    validBSBRequired: "Por favor, proporcione un código BSB válido",
    validIFSCRequired: "Por favor, proporcione un código IFSC válido",
  },
};
